<template>

    <div class="anexo-7 contenedor-data -full">
        <template v-if="!edit">
            <h4 class="data-title" :style="styles.colorBasic">{{doc.nombre}} - {{doc.estado}}</h4>
            <p v-if="doc.ObservacionesAlumno"><strong>Observaciones del alumno:</strong> {{doc.ObservacionesAlumno}}</p>
            <p v-if="doc.ObservacionesTutor"><strong>Observaciones del tutor:</strong> {{doc.ObservacionesTutor}}</p>
            <a :href="doc.enlace" target="_blank" class="row-start enlace-cuestionario" :style="styles.colorBasic">Ver
                documento<only-arrow></only-arrow></a>
            <div class="contenedor-botones row-start" v-if="doc.validado === null">
                <a class="btn -xs" :style="styles.solidPrimary" @click="validate">Validar</a>
                <a class="btn -skull -xs" :style="styles.skull_primary" @click="reject">Rechazar</a>
                <a class="edit" @click="edit = true"><edit></edit></a>
            </div>
        </template>

        <template v-if="edit">

            <div class="contenedor-input -wo-padding">
                <label for="">Observaciones</label>
                <input :style="styles.input_black" type="text" v-model="data.Observaciones">
              </div>
      

            <div class="contenedor-botones row-start">
                <a class="btn -xs" :style="styles.solidPrimary" @click="sendData" :loading="loading">Guardar</a>
                <a class="btn -skull -xs" :style="styles.skull_primary" @click="edit = false">Cancelar</a>
            </div>

        </template>

    </div>


</template>


<script>

    import {
        mapGetters,
        mapActions
    } from 'vuex';

    import onlyArrow from '@/components/parts/icons/only-arrow';
    import edit from '@/components/parts/icons/edit';

    export default {
        name: 'anexo-7',
        props: ['doc'],
        mounted(){
            this.data.idDocumento = this.doc.id;
            this.data.idPractica = this.$route.params.id;
            this.data.Observaciones = this.doc.ObservacionesTutor;
            this.data.validado = this.doc.validado;
        },
        data: () => ({
            edit: false,
            data: {
                "idPractica":'',
                "Observaciones": "",
                "validado": ''
            },
            loading : false,
        }),
        methods : {
            ...mapActions(['editDocumentoCF']),
            validate(){
                this.data.validado = true;
                this.sendData();
            },
            reject(){
                this.data.validado = false;
                this.sendData();
            },
            sendData(){
                this.loading = true;
                this.editDocumentoCF(this.data).then(r => {
                    if(r){
                        this.$emit('refresh');
                        this.edit = false;
                    }
                    this.loading = false;
                })
            }
        },
        computed: {
            ...mapGetters({
                styles: 'getStyles',
                brand: 'getBrand'
            }),
        },
        components: {
            'only-arrow': onlyArrow,
            'edit' : edit
        }
    }
</script>


<style lang="scss" scoped>
    .contenedor-botones {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;

        .btn {
            text-decoration: none;
            margin-right: 8px;
        }
    }

    .anexo-7 {
        padding-bottom: 15px;
        border-bottom: 1px solid #ddd;
        position: relative;
    }

    .edit{
        width: 40px;
        height: 40px;
        display: inline-block;
        border-radius: 50%;
        text-align: center;
        line-height: 40px;
        position: absolute;
        right: 0;
        top: 0;
    }

    .enlace-cuestionario {
        font-size: 14px;
        text-transform: uppercase;
        margin-right: 5px;
        font-weight: 600;
        width: 100%;
        text-decoration: underline;
        cursor: pointer;

        svg {
            width: 15px;
            margin-left: 5px;
        }
    }

    p{
        width: 100%;
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/anexo-7.vue